import { Capacitor } from '@capacitor/core';

// Environment detection - auto-detect based on hostname (evaluated at runtime)
const getIsProduction = () => {
  if (typeof window === 'undefined') {
    // Server-side or module load time - default to production for native apps
    return true;
  }
  
  // Check if running in native Android app - multiple detection methods
  let isNativeAndroid = false;
  
  try {
    // Method 1: Capacitor detection
    if (Capacitor && Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
      const platform = Capacitor.getPlatform();
      if (platform === 'android') {
        isNativeAndroid = true;
        console.log('🎯 Native Android detected via Capacitor.isNativePlatform()');
      }
    }
  } catch (e) {
    console.log('🎯 Capacitor check error:', e);
  }
  
  // Method 2: Check hostname for Capacitor protocol (capacitor://localhost)
  if (!isNativeAndroid && typeof window !== 'undefined') {
    const protocol = window.location.protocol;
    
    // Capacitor apps use capacitor:// protocol
    if (protocol === 'capacitor:' || protocol === 'capacitor-http:' || protocol === 'capacitor-https:') {
      isNativeAndroid = true;
      console.log('🎯 Native Android detected via Capacitor protocol:', protocol);
    }
    
    // Method 3: Check user agent for Android WebView
    if (!isNativeAndroid && navigator.userAgent) {
      const ua = navigator.userAgent;
      // Android WebView user agent contains "wv" (WebView)
      if (/Android/i.test(ua) && /wv/i.test(ua)) {
        // Not a regular browser - it's WebView (native app)
        isNativeAndroid = true;
        console.log('🎯 Native Android detected via WebView user agent');
      }
    }
  }
  
  // If native Android, always use production
  if (isNativeAndroid) {
    return true;
  }
  
  // Web browser - check hostname
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  return hostname === 'easyhealthdigital.com' || hostname === 'www.easyhealthdigital.com' || 
         hostname === 'bookmyop.co.in' || hostname === 'www.bookmyop.co.in';
};

// Function to detect development environment
const getIsDevelopment = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  
  const hostname = window.location.hostname;
  // Check if running on development domain
  return hostname === 'dev.easyhealthdigital.com' || hostname.includes('localhost') || hostname.includes('127.0.0.1');
};

// Function to get backend host - detects Android automatically
const getBackendHost = () => {
  // FOR CLIENT/PROD TESTING: Always use cloud backend
  const isProd=true;
  return isProd?'https://dev.easyhealthdigital.com':'http://localhost:8000';
};

// Use getter to ensure detection happens at runtime, not module load time
let _backendConfig = null;

const getBackendConfig = () => {
  if (!_backendConfig) {
    const host = getBackendHost();
    
    // Determine WebSocket host - use same host as backend
    // For local development (localhost:8000 or 10.0.2.2:8000), use the same host
    const wsHost = host.replace('http://', '').replace('https://', '');
    
    _backendConfig = {
      host: host,
      ws: {
        host: wsHost,
        endpoints: {
          admin: '/ws/admin/notifications',
          bda: '/ws/bda/notifications',
          patient: '/ws/patient/notifications'
        }
      }
    };
  }
  return _backendConfig;
};

export const config = {
  debugOtp: false,
  mapsApiKey: 'AIzaSyA6xFjorrByqcT7crcd17DwnTLR8GoR5ac',

  // Backend configuration - uses getter to ensure runtime detection
  get backend() {
    return getBackendConfig();
  }
};

// Debug log final config (delayed to ensure Capacitor is initialized)
if (typeof window !== 'undefined') {
  // Use multiple delays to ensure Capacitor is ready
  const logConfig = () => {
    try {
      const backend = config.backend;
      const isProduction = getIsProduction();
      const platform = Capacitor ? Capacitor.getPlatform() : 'web';
      const isNative = Capacitor ? Capacitor.isNativePlatform() : false;
      const hostname = window.location.hostname;
      const protocol = window.location.protocol;
      const userAgent = navigator.userAgent?.substring(0, 100) || 'N/A';
      
      console.log('🎯 Final Config (Runtime):', {
        environment: isProduction ? 'Production' : 'Local',
        backendHost: backend.host,
        wsHost: backend.ws.host,
        platform,
        isNative,
        hostname,
        protocol,
        userAgent: userAgent
      });
      
      // Also log to window for easier debugging
      if (window.__BOOKMYOP_CONFIG__) {
        window.__BOOKMYOP_CONFIG__ = {
          backendHost: backend.host,
          isProduction,
          platform,
          isNative,
          hostname,
          protocol
        };
      }
    } catch (e) {
      console.error('Error logging config:', e);
    }
  };
  
  // Try multiple times to catch Capacitor initialization
  if (window.requestAnimationFrame) {
    window.requestAnimationFrame(() => {
      setTimeout(logConfig, 100);
      setTimeout(logConfig, 500);
      setTimeout(logConfig, 1000);
    });
  }
  
  // Also log immediately
  setTimeout(logConfig, 100);
}

export default config;

